import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import axios from 'axios';

const EventForm = () => {
    const { label } = useParams();
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        agree: false
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        // Regular expression for valid email with proper domain
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|co\.uk|org|net|edu|gov|info|biz|io|ai|us|ca|au|in|pk)$/;

        if (!emailPattern.test(formData.email)) {
            setAlertType('error');
            setAlertMessage('Please enter a valid email address.');
            setShowAlert(true);
            setTimeout(() => setShowAlert(false), 3000);
            return;
        }
        try {
            const data = new FormData();
            data.append('first_name', formData.first_name);
            data.append('last_name', formData.last_name);
            data.append('phone', formData.phone);
            data.append('email', formData.email);
            data.append('program_name', label);

            let baseUrl = process.env.REACT_APP_BASE_URL;
            const response = await axios.post(baseUrl + '/store', data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            const { event_id, user_email, user_phone } = response.data;
            if (response.data) {
                localStorage.setItem('event_id', event_id);
                localStorage.setItem('user_email', user_email);
                localStorage.setItem('user_phone', user_phone);
            }
            console.log("response data event id:", response.data.event_id);
            console.log("Form Data:", response);
            setAlertType('success');
            setAlertMessage('Event stored successfully!');
            setShowAlert(true);
            setTimeout(() => {
                setShowAlert(false);
                navigate(`/${label}`);
            }, 3000);
        } catch (err) {
            setAlertType('error');
            setAlertMessage('Failed to store Event. Please try again.');
            setShowAlert(true);
            setTimeout(() => setShowAlert(false), 3000);
        } finally {
            setLoading(false);
        }
    };

    const languageData = {
        personal: {
            name: "Personal Occasions",
            description: "Protect your special day with comprehensive coverage for personal events and celebrations.",
            description2: "Plan boldly-our coverage has your back."
        },
        professional: {
            title: "Your industry events, secured with expert coverage",
            name: "Professional",
            description: "Safeguard your success with tailored insurance for exhibitions and professional events.",
            description2: "Ensure your business shines with customized insurance for trade shows, industry gatherings and events",
        },
        sports: { title: "Your game, Your rules-our insurance keep it save", name: "Sports", description: "Keep the game on—reliable insurance for sporting events of all sizes." },
        vendor: { title: "Set up, Sell, succeed-insured at every step", name: "Vendor", description: "Secure your stall, sell with confidence—coverage designed for vendors at any event." },
    };
    const selectedLanguage = languageData[label];
    return (
        <>
            <section>
                <div className="events-section">
                    <Container>
                        <div className="events__form pad__100">
                            <Row className='align-items-center'>
                                <Col md={6}>
                                    {selectedLanguage ? (
                                        <>
                                            <div className="event__form__content">
                                                <h4>{selectedLanguage.title}</h4>
                                                <h5>{selectedLanguage.name}</h5>
                                                <p>{selectedLanguage.description}</p>
                                                <p>{selectedLanguage.description2}</p>
                                            </div>
                                        </>
                                    ) : (
                                        <p>Language not found!</p>
                                    )}
                                </Col>
                                {/* <Col md={6}>
                                    <div className="event__form__content">
                                        <h5>Personal Occasions</h5>
                                        <h1>Safeguard your special day</h1>
                                        <p>Gain peace of mind and protect your investment if unforeseen circumstances lead to event changes or postponement.</p>
                                        <ul>
                                            <li>
                                                Comprehensive protection covers accidents, property damage, & unexpected incidents
                                                <span><FaCheckCircle /></span>
                                            </li>
                                            <li>
                                                Coverage flexibility lets you get just what you need for peace of mind
                                                <span><FaCheckCircle /></span>
                                            </li>
                                            <li>
                                                Easy setup with fast policy activation & a simple online application
                                                <span><FaCheckCircle /></span>
                                            </li>
                                        </ul>
                                    </div>
                                </Col> */}
                                <Col md={6} className=''>
                                    <div className="event__form__input">
                                        {loading && <div>loading....</div>}
                                        {showAlert && (
                                            <Alert
                                                variant={alertType === 'success' ? 'success' : 'danger'}
                                                onClose={() => setShowAlert(false)}
                                                dismissible
                                            >
                                                {alertMessage}
                                            </Alert>
                                        )}
                                        <h2>Get a Free Quote</h2>
                                        <form onSubmit={handleSubmit}>
                                            <Row>
                                                <Col md={6} className='mb-3'>
                                                    <label htmlFor='first_name' className='form-label'>First Name</label>
                                                    <input type='text' id='first_name' name='first_name' className='form-control' required onChange={handleChange} />
                                                </Col>
                                                <Col md={6} className='mb-3'>
                                                    <label htmlFor='last_name' className='form-label'>Last Name</label>
                                                    <input type='text' id='last_name' name='last_name' className='form-control' required onChange={handleChange} />
                                                </Col>
                                                <Col md={6} className='mb-3'>
                                                    <label htmlFor='phone' className='form-label'>Phone</label>
                                                    <input type='text' id='phone' name='phone' className='form-control' required onChange={handleChange} onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ""); }} />
                                                </Col>
                                                <Col md={6} className='mb-3'>
                                                    <label htmlFor='email' className='form-label'>Email</label>
                                                    <input type='email' id='email' name='email' className='form-control' required onChange={handleChange} />
                                                </Col>
                                                <Col md={12} className='mb-3'>
                                                    <input type='checkbox' id='agree' name='agree' className='me-2' required onChange={handleChange} />
                                                    <label htmlFor='agree' className='form-label'>I Agree</label>
                                                </Col>
                                                <Col md={12} className='mb-3'>
                                                    <p>
                                                        By pressing “I Agree” you consent to receive text messages from All Events Insure.
                                                        Messaging frequency varies. Message and data rates may apply. Expect important
                                                        notifications about our services, updates on upcoming meetings, and replies from
                                                        your dedicated representative. You can opt out at any time by replying "STOP" to any message.
                                                        Reply "HELP" for assistance. For more information, please read our Terms of Service
                                                        and Privacy Policy
                                                    </p>
                                                </Col>
                                                <Col md={12} className='mb-4'>
                                                    <button type='submit' className='event__form__btn'>Get Started</button>
                                                </Col>
                                            </Row>
                                        </form>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div>
            </section>
        </>
    )
}

export default EventForm